var React = require('react');

function Placeholder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0zm0 0h24v24H0zm21 19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2","fill":"none","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1}),React.createElement("path",{"d":"M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z","key":2})]);
}

Placeholder.displayName = "Placeholder";

Placeholder.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Placeholder;

Placeholder.default = Placeholder;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Placeholder.svg
// module id = 650
// module chunks = 168707334958949